<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen" >
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>

		<div class="content">
			<div class="container">

				<div class="text-center">
					Cargar combustible
				</div>
				<div class="d-flex align-items-center justify-content-center">

					<b-form-group label="Cantidad de combustible" class="mt-4">
						
						<div class="input-group" style="width:190px;">
							<vue-numeric  
							v-model="form.liters" 
							class="form-control text-right" 
							:precision="0" ></vue-numeric>
							<div class="input-group-append text-center" style="width: 28px;">
								<span class="input-group-text">L</span>
							</div>
						</div>
						<b-form-invalid-feedback>Ingrese una price</b-form-invalid-feedback>
					</b-form-group>

					<b-form-group label="Tipo de combustible" class="mt-4">
						<div class="input-group" >
							<select name="type" v-model="form.type" class="form-control">
								<option value="GASOLINE">Nafta</option>
								<option value="DIESEL">Diesel</option>
							</select>
						</div>
					</b-form-group>
				</div>
				

				<!-- <b-form-group label="Comentarios" class="mt-4">
					<textarea-autosize
					placeholder="Comentarios"
					v-model="form.comments"
					:min-height="30"
					:max-height="350"
					class="form-control"
					/>
				</b-form-group> -->
				
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="finishControl()">
					Continuar
				</div>
			</div>
		</div>
	</div>
	
	
</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'CarFuelLoad',
	mixins:[mixins],
	components: {
		Loader,
	},
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
			loading: false,

			form:{
				liters: null,
				type: 'gasoline',
			}
		}
	},
	computed: {
		...mapState(['control'])
	},
	validators: {
		'form.liters': function (value) {
			return Validator.value(value).required();
		},
		'form.type': function (value) {
			return Validator.value(value).required();
		},
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		
		async finishControl(){
			if(!this.loading && await this.checkValidation() ) {
				this.loading = true
				let dataInput = {
					car_id		: this.control.car.id,
					liters : this.form.liters,
					type : this.form.type
				}
				this.$apollo.mutate({
					mutation: gql`mutation ( $data:ControlFuelLoadInput! ){
						controlFuelLoad( data: $data) {
							id
							
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.controlCreated = data.data.controlFuelLoad
					this.loading = false
					this.$toast.success(`La carga de combustible se ha registrado correctamente`)
					this.$router.push(`/control/${this.control.car.id}`)
				})
				.catch( (error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
			}
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
